module.exports = __webpack_public_path__ + "img/stanley.a512efe5.png";